import { render, staticRenderFns } from "./MyTaskNotifyList.vue?vue&type=template&id=74a7cf12&scoped=true&"
import script from "./MyTaskNotifyList.vue?vue&type=script&lang=js&"
export * from "./MyTaskNotifyList.vue?vue&type=script&lang=js&"
import style0 from "./MyTaskNotifyList.vue?vue&type=style&index=0&id=74a7cf12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7cf12",
  null
  
)

export default component.exports